module.exports = __webpack_public_path__ + "static/baranski-drzwi-47fb2426e10f4ecd2378199dc6ddcf1c.svg";